import { Icoupon } from '@/redux/reducers/guest';
import { CouponStatus, CouponTabStatus } from '@/config/constant';
import { fetchCouponList } from '@/api/guest';

interface CouponInfo extends Icoupon {
  FEStatus: CouponStatus; // 前端状态
}

class WYCouponService {
  private couponList: CouponInfo[] = []; // 本店可用券列表（包含锁定状态券）

  private couponOwnerId: string; // 券所属uid

  // 更新券列表
  private updateCouponList = (list: CouponInfo[]) => {
    this.couponList = list;
  };

  // 遍历券列表
  private traversalList = (handler: (item: CouponInfo) => void) => {
    try {
      this.couponList.forEach(handler);
    } catch (e) {
      //
    }
  };

  // 批量锁定券
  public batchLockCoupon = (list: string[]) => {
    if (list && list.length) {
      const updateList: CouponInfo[] = [];
      const lockMap: { [couponNo: string]: boolean } = {};
      list.forEach((couponNo) => {
        lockMap[couponNo] = true;
      });
      this.traversalList((item) => {
        if (lockMap[item.couponNo]) {
          updateList.push({
            ...item,
            FEStatus: CouponStatus.Locked,
          });
        } else {
          updateList.push(item);
        }
      });
      this.updateCouponList(updateList);
    }
  };

  // 批量解锁券
  public batchUnlockCoupon = (list: string[]) => {
    if (list && list.length) {
      const updateList: CouponInfo[] = [];
      const unlockMap: { [couponNo: string]: boolean } = {};
      list.forEach((couponNo) => {
        unlockMap[couponNo] = true;
      });
      this.traversalList((item) => {
        if (unlockMap[item.couponNo]) {
          updateList.push({
            ...item,
            FEStatus: CouponStatus.Effective,
          });
        } else {
          updateList.push(item);
        }
      });
      this.updateCouponList(updateList);
    }
  };

  // 重置券状态
  public resetListStatus = () => {
    const updateList: CouponInfo[] = [];
    this.traversalList((item) => {
      updateList.push({
        ...item,
        FEStatus: item.status,
      });
    });
    this.updateCouponList(updateList);
  };

  // 获取券列表
  public fetchCouponList = (uid: string) => {
    return new Promise<boolean>((resolve) => {
      this.updateCouponList([]);
      this.couponOwnerId = uid;
      if (uid) {
        // 筛选本店可用券
        fetchCouponList({ wyuid: uid, couponStatus: CouponTabStatus.CanUse })
          .then((res) => {
            return res.data.couponList;
          })
          .catch(() => {
            return null;
          })
          .then((list) => {
            if (this.couponOwnerId === uid) {
              this.updateCouponList(list || []);
              this.resetListStatus();
              resolve(true);
            } else {
              resolve(false);
            }
          });
      } else {
        resolve(true);
      }
    });
  };

  // 获取可用券数量
  public getAVLCount = (excludeArr: string[]) => {
    let count = 0;
    const excludeMap = {};
    (excludeArr || []).forEach((couponNo) => {
      if (couponNo) {
        excludeMap[couponNo] = true;
      }
    });
    // 有效 或者 锁定但不包含
    this.traversalList((item) => {
      const { couponNo, FEStatus } = item;
      // 有效
      const isEffective = FEStatus === CouponStatus.Effective;
      // 锁定 且不包含
      const isExclude = FEStatus === CouponStatus.Locked && excludeMap[couponNo];
      if (isEffective || isExclude) {
        count += 1;
      }
    });
    return count;
  };
}

export default WYCouponService;
